import { render, staticRenderFns } from "./v-upload-image.vue?vue&type=template&id=4b20866c&scoped=true&"
import script from "./v-upload-image.vue?vue&type=script&lang=js&"
export * from "./v-upload-image.vue?vue&type=script&lang=js&"
import style0 from "./v-upload-image.vue?vue&type=style&index=0&id=4b20866c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20866c",
  null
  
)

export default component.exports